import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Login } from '../../../models/Login';
import { UsuarioService } from '../../usuario/service/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoService {

  constructor(private http: HttpClient, private usuarioService: UsuarioService) { }

  autenticacao(Login: Login) {
    return this.http.post(`${environment.urlApi}/login`, Login,
      { observe: 'response' }).pipe(
        tap((response: any) => {
          const authToken = response.body.access_token;
          this.usuarioService.salvarToken(authToken);
        })
      );
  }

}
